import { defer } from '@lib/router'
import { api as eventApi } from '@app/services/auto-generated/event'
import { store } from '@app/store'

const liveEventLoader = async () => {
  const events = promise()
  return defer({ events })
}

const promise = async () => {
  const result = await store.dispatch(
    eventApi.endpoints.eventGetEvents.initiate({ isDashboard: false }),
  )

  if (result.isError || !result.data || !(result.data.events.length > 0)) {
    throw new Error('Page not found')
  }

  return result
}

export default liveEventLoader
